import {
  getColorClassNames,
  cx,
  ButtonVariant,
  Color,
  colorPalette,
} from '@UI/lib/utils';

export const iconSizes: {
  [size: string]: {
    height: string;
    width: string;
  };
} = {
  xs: {
    height: 'h-4',
    width: 'w-4',
  },
  sm: {
    height: 'h-5',
    width: 'w-5',
  },
  md: {
    height: 'h-5',
    width: 'w-5',
  },
  lg: {
    height: 'h-6',
    width: 'w-6',
  },
  xl: {
    height: 'h-6',
    width: 'w-6',
  },
};

export const getButtonProportions = (variant: ButtonVariant) => {
  if (!(variant === 'ghost')) {
    return {
      xs: {
        paddingX: 'px-2.5',
        paddingY: 'py-1.5',
        fontSize: 'text-xs',
      },
      sm: {
        paddingX: 'px-4',
        paddingY: 'py-2',
        fontSize: 'text-sm',
      },
      md: {
        paddingX: 'px-4',
        paddingY: 'py-2',
        fontSize: 'text-md',
      },
      lg: {
        paddingX: 'px-4',
        paddingY: 'py-2.5',
        fontSize: 'text-lg',
      },
      xl: {
        paddingX: 'px-4',
        paddingY: 'py-3',
        fontSize: 'text-xl',
      },
    };
  }
  return {
    xs: {
      paddingX: '',
      paddingY: '',
      fontSize: 'text-xs',
    },
    sm: {
      paddingX: '',
      paddingY: '',
      fontSize: 'text-sm',
    },
    md: {
      paddingX: '',
      paddingY: '',
      fontSize: 'text-md',
    },
    lg: {
      paddingX: '',
      paddingY: '',
      fontSize: 'text-lg',
    },
    xl: {
      paddingX: '',
      paddingY: '',
      fontSize: 'text-xl',
    },
  };
};

export const getButtonColors = (variant: ButtonVariant, color?: Color) => {
  switch (variant) {
    case 'primary':
      return {
        textColor: color
          ? // ? getColorClassNames("white").textColor
            'text-revving-background dark:text-darkRevving-background'
          : 'text-revving-brand-inverted dark:text-darkRevving-brand-inverted',
        hoverTextColor: color
          ? getColorClassNames('white').textColor
          : 'text-revving-brand-inverted dark:text-darkRevving-brand-inverted',
        bgColor: color
          ? getColorClassNames(color, colorPalette.background).bgColor
          : 'bg-revving-brand dark:bg-darkRevving-brand',
        hoverBgColor: color
          ? getColorClassNames(color, colorPalette.darkBackground).hoverBgColor
          : 'hover:bg-revving-brand-emphasis dark:hover:bg-darkRevving-brand-emphasis',
        borderColor: color
          ? getColorClassNames(color, colorPalette.border).borderColor
          : 'border-revving-brand dark:border-darkRevving-brand',
        hoverBorderColor: color
          ? getColorClassNames(color, colorPalette.darkBorder).hoverBorderColor
          : 'hover:border-revving-brand-emphasis dark:hover:border-darkRevving-brand-emphasis',
      };
    case 'secondary':
      return {
        textColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'text-revving-brand dark:text-darkRevving-brand',
        hoverTextColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'hover:text-revving-brand-emphasis dark:hover:text-darkRevving-brand-emphasis',
        bgColor: getColorClassNames('transparent').bgColor,
        hoverBgColor: color
          ? cx(
              getColorClassNames(color, colorPalette.background).hoverBgColor,
              'hover:bg-opacity-20 dark:hover:bg-opacity-20',
            )
          : 'hover:bg-revving-brand-faint dark:hover:bg-darkRevving-brand-faint',
        borderColor: color
          ? getColorClassNames(color, colorPalette.border).borderColor
          : 'border-revving-brand dark:border-darkRevving-brand',
      };
    case 'light':
      return {
        textColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'text-revving-brand dark:text-darkRevving-brand',
        hoverTextColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'hover:text-revving-brand-emphasis dark:hover:text-darkRevving-brand-emphasis',
        bgColor: color
          ? cx(
              getColorClassNames(color, colorPalette.background).bgColor,
              'bg-opacity-20 dark:bg-opacity-20',
            )
          : 'bg-revving-brand-faint dark:bg-darkRevving-brand-faint',
        hoverBgColor: color
          ? cx(
              getColorClassNames(color, colorPalette.background).hoverBgColor,
              'hover:bg-opacity-40 dark:hover:bg-opacity-40',
            )
          : 'hover:bg-revving-brand-muted dark:hover:bg-darkRevving-brand-muted',
        borderColor: color
          ? getColorClassNames(color, colorPalette.border).borderColor
          : 'border-revving-brand dark:border-darkRevving-brand',
      };
    case 'ghost':
      return {
        textColor: color
          ? getColorClassNames(color, colorPalette.text).textColor
          : 'text-revving-brand dark:text-darkRevving-brand',
        hoverTextColor: color
          ? getColorClassNames(color, colorPalette.darkText).hoverTextColor
          : 'hover:text-revving-brand-emphasis dark:hover:text-darkRevving-brand-emphasis',
        bgColor: getColorClassNames('transparent').bgColor,
        borderColor: '',
        hoverBorderColor: '',
      };
  }
};
